(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aside"] && !Shopify.designMode) return;
  try {
    // 多方向可重复侧边栏
class Pushbar {
    constructor(config = { overlay: true, blur: false }) {
        this.activeId;
        this.activeElement;
        this.overlayElement;
        if (config.overlay) {
            this.overlayElement = document.createElement('div');
            this.overlayElement.classList.add('pushbar_overlay');
            document.querySelector('body').appendChild(this.overlayElement);
        }
        if (config.blur) {
            const mainContent = document.querySelector('.pushbar_main_content');
            if (mainContent) {
                mainContent.classList.add('pushbar_blur');
            }
        }
        this.bindEvents();
    }

    emitOpening(data) {
        const event = new CustomEvent('pushbar_opening', { bubbles: true, detail: { element: this.activeElement, id: this.activeId, data } });
        this.activeElement.dispatchEvent(event);
    }

    emitClosing() {
        const event = new CustomEvent('pushbar_closing', { bubbles: true, detail: { element: this.activeElement, id: this.activeId } });
        this.activeElement.dispatchEvent(event);
    }

    handleOpenEvent(e) {
        e.preventDefault();
        const pushbarId = e.currentTarget.getAttribute('data-pushbar-target');
        this.open(pushbarId);
    }

    handleCloseEvent(e) {
        e.preventDefault();
        this.close();
    }

    handleKeyEvent(e) {
        if (e.keyCode === 27) this.close();
    }

    bindEvents() {
        const triggers = document.querySelectorAll('[data-pushbar-target]');
        const closers = document.querySelectorAll('[data-pushbar-close]');
        triggers.forEach(trigger => trigger.addEventListener('click', e => this.handleOpenEvent(e), false));
        closers.forEach(closer => closer.addEventListener('click', e => this.handleCloseEvent(e), false));
        if (this.overlayElement) {
            this.overlayElement.addEventListener('click', e => this.handleCloseEvent(e), false);
        }
        document.addEventListener('keyup', e => this.handleKeyEvent(e));
    }

    open(pushbarId) {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (this.activeId === String(pushbarId) || !pushbarId) return;
        if (this.activeId && this.activeId !== String(pushbarId)) this.close();
        this.activeId = pushbarId
        this.activeElement = document.querySelector(`[data-pushbar-id="${this.activeId}"]`)
        if (!this.activeElement) return;
        this.emitOpening();
        this.activeElement.classList.add('hs-opened');
        const pageRootElement = document.querySelector('html')
        pageRootElement.classList.add('pushbar_locked');
        pageRootElement.setAttribute('pushbar', pushbarId)
        pageRootElement.style.paddingRight = scrollbarWidth + 'px'
    }

    close() {
        if (!this.activeId) return;
        this.emitClosing();
        this.activeElement.classList.remove('hs-opened');
        const pageRootElement = document.querySelector('html')
        pageRootElement.classList.remove('pushbar_locked');
        pageRootElement.removeAttribute('pushbar')
        pageRootElement.style.paddingRight = 0
        this.activeId = null;
        this.activeElement = null;
    }
}

// 初始化弹窗
const pushbar = new Pushbar({blur: true,overlay: true})
window.hsPushbar = pushbar

// 初始化关闭点击事件
const asideLeft = document.querySelector('[data-pushbar-id="left"]');
const asideRight = document.querySelector('[data-pushbar-id="right"]');
const asideTop = document.querySelector('[data-pushbar-id="top"]');
const asideBottom = document.querySelector('[data-pushbar-id="bottom"]');
const asideMMenu = document.querySelector('[data-pushbar-id="m-menu"]');

asideLeft.addEventListener('click', function (e) {
  if (e.target.closest('[data-pushbar-close]')) {window.hsPushbar.close('left')}
});
asideRight.addEventListener('click', function (e) {
  if (e.target.closest('[data-pushbar-close]')) {window.hsPushbar.close('right')}
});
asideTop.addEventListener('click', function (e) {
  if (e.target.closest('[data-pushbar-close]')) {window.hsPushbar.close('top')}
});
asideBottom.addEventListener('click', function (e) {
  if (e.target.closest('[data-pushbar-close]')) {window.hsPushbar.close('bottom')}
});
asideMMenu.addEventListener('click', function (e) {
  if (e.target.closest('[data-pushbar-close]')) {window.hsPushbar.close('m-menu')}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-super-filter"] && !Shopify.designMode) return;
  try {
    // 监听超级菜单tab点击事件
document.addEventListener('super:menu:tab:click', function() {
  console.log('tab click');
  clearFilter(superContainer);
});


const superContainer = document.querySelector('.hs-header__menu-mega')
initFilter(superContainer)
clearFilter(superContainer)

document.addEventListener('mmenu:dom:loaded', function() {
  const mSuperConter = document.querySelector('.hs-mmenu')
  initFilter(mSuperConter)
  clearFilter(mSuperConter)
})

// 清除筛选状态
function clearFilter(container) {
  const activeItems = container.querySelectorAll('[data-icon-id].active');
  const productHiddenItems = container.querySelectorAll('[data-filter].hidden');
  activeItems.forEach(item => {
    item.classList.remove('active');
  });
  productHiddenItems.forEach(item => {
    item.classList.remove('hidden');
  });
}



// 初始化筛选功能
function initFilter(container) {
  const filterItems = container.querySelectorAll('[data-icon-id]');
  filterItems.forEach(item => {
    item.addEventListener('click', function() {
      item.classList.toggle('active');
      const curFilterBox = item.closest('[data-filter-box]')
      if(!curFilterBox) return
      // Collect all active filter icon IDs
      const activeIds = Array.from(curFilterBox.querySelectorAll('[data-icon-id].active'))
        .map(f => f.dataset.iconId);

      // Scope product items to the current mega panel only
      const currentPanel = item.closest('[data-filter-box]');
      const productItems = currentPanel ? currentPanel.querySelectorAll('[data-filter]') : [];

      productItems.forEach(product => {
        // Use data-filter attribute (matches the Liquid template)
        const iconIds = product.dataset.filter ? product.dataset.filter.split(',') : [];
        // Show product only if it matches ALL active filters (AND logic), or if no filter is active
        const hasMatch = activeIds.length === 0 || activeIds.every(id => iconIds.includes(id));
        product.classList.toggle('hidden', !hasMatch);
      });
    });
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-global-menu-widget"] && !Shopify.designMode) return;
  try {
    if (customElements.get('hs-global-menu-widget')) return;

    class HsGlobalMenuWidget extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
      }

      connectedCallback() {
        var dataScript = document.getElementById('hs-global-menu-data');
        if (!dataScript) return;

        var parsed;
        try {
          parsed = JSON.parse(dataScript.textContent);
        } catch (e) {
          return;
        }

        var current = parsed.current || {};
        var sites = parsed.sites || [];

        var style = document.createElement('style');
        style.textContent = `
          :host {
            line-height: 0;
            padding: 0 0.625em;
          }
          .menu {
            position: relative;
            display: inline-block;
            --flag-width: 25px;
            --flag-radius: 2px;
            --font-color: inherit;
          }
          .menu .main {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border-radius: 50%;
            overflow: hidden;
          }
          .menu .main:hover {
            background: rgba(0, 0, 0, 0.1);
          }
          .main-flag {
            border-radius: var(--flag-radius);
            width: var(--flag-width);
            aspect-ratio: 1;
            object-fit: cover;
          }
          .menu.active .dropdown {
            display: block;
          }
          .dropdown {
            position: absolute;
            top: 120%;
            right: 0;
            background: #ffffff;
            display: none;
            min-width: 100%;
            max-width: 400px;
            border-radius: 5px;
            overflow: hidden;
            color: var(--font-color);
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
            z-index: 5;
          }
          .dropdown .link {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 15px;
            color: #000000;
            text-decoration: none;
            border-bottom: 1px solid rgba(0, 0, 0, 0.04);
          }
          .dropdown .link:last-child {
            border-bottom: none;
          }
          .dropdown .link:hover {
            background: rgba(0, 0, 0, 0.05);
          }
          .dropdown .flag {
            border-radius: var(--flag-radius);
            width: var(--flag-width);
            margin: 0;
            padding: 0;
          }
          .dropdown .name {
            font-size: 16px;
            font-weight: 400;
            line-height: 1;
            white-space: nowrap;
          }
          .main:after {
            position: absolute;
            content: '';
            width: 100%;
            height: 100%;
            top: 20%;
            left: 0;
          }
          @media (max-width: 900px) {
            .dropdown .name {
              font-size: 14px;
            }
            .menu .main {
              padding: 0;
              background: rgba(0, 0, 0, 0);
              box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
            }
            .dropdown .link {
              padding: 10px 15px;
              border-bottom: 1px solid rgba(0,0,0, 0.04);
            }
          }
        `;

        var container = document.createElement('div');
        container.className = 'menu';
        container.innerHTML = ''
          + '<div class="main">'
          +   '<img class="main-flag" loading="lazy" alt="">'
          + '</div>'
          + '<div class="dropdown"></div>';

        var mainFlag = container.querySelector('.main-flag');
        if (mainFlag && current && current.flag) {
          mainFlag.src = current.flag;
          if (current.country) {
            mainFlag.alt = current.country;
          }
        }

        var dropdown = container.querySelector('.dropdown');
        if (dropdown && Array.isArray(sites)) {
          sites.forEach(function(site) {
            if (!site || !site.url) return;

            var link = document.createElement('a');
            link.className = 'link';
            link.href = site.url;

            var img = document.createElement('img');
            img.className = 'flag';
            img.loading = 'lazy';
            if (site.flag) img.src = site.flag;
            if (site.country) img.alt = site.country;

            var span = document.createElement('span');
            span.className = 'name';
            span.textContent = site.country || '';

            link.appendChild(img);
            link.appendChild(span);
            dropdown.appendChild(link);
          });
        }

        this.shadowRoot.appendChild(style);
        this.shadowRoot.appendChild(container);

        var globalBtn = container.querySelector('.main');
        if (!globalBtn) return;

        globalBtn.addEventListener('click', function(event) {
          event.stopPropagation();
          container.classList.toggle('active');
        });

        document.addEventListener('click', function(event) {
          if (!container.contains(event.target)) {
            container.classList.remove('active');
          }
        });
      }
    }

    customElements.define('hs-global-menu-widget', HsGlobalMenuWidget);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-language-switch-widget"] && !Shopify.designMode) return;
  try {
    class HsLocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul')
    };
    if (!this.elements.button || !this.elements.panel || !this.elements.input) return;

    

    this.openSelector = this.openSelector.bind(this);
    this.closeSelector = this.closeSelector.bind(this);
    this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
    this.onItemClick = this.onItemClick.bind(this);

    this.elements.button.addEventListener('click', this.openSelector);
    this.elements.button.addEventListener('focusout', this.closeSelector);
    this.addEventListener('keyup', this.onContainerKeyUp);
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    var value = event.currentTarget.dataset.value;
    if (!value) return;
    var form = this.querySelector('form');
    this.elements.input.value = value;
    if (form) form.submit();
  }

  openSelector() {
    var expanded = this.elements.button.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      this.hidePanel();
    } else {
      this.elements.panel.removeAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.button.focus();
    }
  }

  closeSelector(event) {
    var related = event.relatedTarget;
    var shouldClose = !related || related.nodeName === 'BUTTON';
    if (shouldClose) {
      this.hidePanel();
    }
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('hs-localization-form', HsLocalizationForm);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["m-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('mmenu:click', function() {
    if(window.hsPushbar) {
      window.hsPushbar.open('m-menu')
    }
  })

  const mMenutmpDom = document.querySelector('#hs-global-mmenu')
  let mMenuHtml = '';
  if (mMenutmpDom) {
    mMenuHtml = mMenutmpDom.innerHTML;
  }

  let isInit = false
  document.addEventListener('pushbar_opening', function(event) {
    if(isInit) return
    const pushbarId = event?.detail?.id;
    if(pushbarId !== 'm-menu') return;
    // 1. 安全地获取目标元素
    const activeElement = event?.detail?.element;
    if (!activeElement || !activeElement.hasAttribute('data-content')) return;

    // 2. 注入 HTML 并获取 DOM
    activeElement.innerHTML = mMenuHtml;
    const mmenuDom = activeElement.querySelector('.hs-mmenu');
    if (!mmenuDom) return;

    // 3. 提取默认返回配置（设置合理的默认值）
    let backIconUrl = mmenuDom.dataset.backIcon || '';
    let backText = mmenuDom.dataset.backText || 'Back';

    // 4. 初始化多级菜单
    new MultiMenu('.hs-mmenu', {
      appendHTML: () => '', // 如果不需要追加内容，直接返回空字符串
      // disableMenuClass: 'hs-header__filter',
      prependHTML: (link) => {
        // 在闭包内声明局部变量，避免污染全局作用域
        let currentBackText = backText; 
        
        // 尝试从当前层级获取自定义返回文案
        const parentLi = link.closest('li');
        const backTextDom = parentLi?.querySelector('.hs-mmenu__link span');
        
        if (backTextDom) {
          currentBackText = backTextDom.textContent.trim() || currentBackText;
        }

        return `<li class="hs-mmenu__back"><a href="#" class="js-menu-back-btn"><img src="${backIconUrl}" alt="back icon" class="hs-mmenu__back-icon" loading="lazy">${currentBackText}</a></li>`;
      }
    });
    document.dispatchEvent(new Event('mmenu:dom:loaded'))
    isInit = true
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["modal"] && !Shopify.designMode) return;
  try {
    window.hs_modal = {
        open,
        close
    }
    const modal = document.querySelector('.hs-modal');
    const contentBox = document.querySelector('.hs-modal__content');
    const closeBtn = document.querySelector('.hs-modal__close');
    let scrollY = 0; // 记录打开前的滚动位置

    // 打开弹窗
    function open(dom) {
        if(!dom) return
        contentBox.innerHTML = '';
        contentBox.append(dom)
        scrollY = window.scrollY;
        document.body.classList.add('hs-modal--active');
        document.body.style.top = `-${scrollY}px`;
        modal.classList.add('active');
        // 自动聚焦可交互元素
        const firstInput = modal.querySelector('input')
        const firstBtn = modal.querySelector('button')
        setTimeout(function () {
            if (firstInput) {
                firstInput.focus();
            } else if (firstBtn) {
                firstBtn.focus();
            }
        }, 100)
    }

    // 关闭弹窗
    function close() {
        modal.classList.remove('active');
        contentBox.innerHTML = '';
        document.body.classList.remove('hs-modal--active');
        document.body.style.top = '';
        
        // 取消css默认的平滑滚动
        const html = document.documentElement;
        const originalBehavior = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';

        window.scrollTo(0, scrollY, 'auto');

        setTimeout(() => {
            html.style.scrollBehavior = originalBehavior;
        }, 50);
    }

    // 事件绑定
    closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
        if (e.target === modal) {
            close();
        }
    });

    // Esc 键关闭
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && modal.classList.contains('active')) {
            close();
        }
    });

    // 可选：焦点捕获（Tab 键在弹窗内循环）
    modal.addEventListener('keydown', e => {
        if (e.key === 'Tab') {
            const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (focusable.length === 0) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        }
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["p-copy-js"] && !Shopify.designMode) return;
  try {
    // coupon code 复制功能
async function handleCopy(e) {
  const btn = e.target.closest('[data-copy-btn]');
  if (!btn) return;

  const codeEl = btn.parentElement.querySelector('[data-copy-data]');
  if (!codeEl) return;

  const code = codeEl.textContent.trim();
  const copiedText = btn.getAttribute('data-copied-text');
  const originalText = btn.getAttribute('data-copy-text');
  const txtEl = btn.querySelector('[data-copy-text-box]');

  try {
    await navigator.clipboard.writeText(code);
    if (txtEl) {
      txtEl.textContent = copiedText;
    } else {
      btn.textContent = copiedText;
    }
    setTimeout(() => {
        if (txtEl) {
          txtEl.textContent = originalText;
        } else {
          btn.textContent = originalText;
        }
    }, 1500);
  } catch (err) {
    console.error('Copy failed:', err);
  }
}

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-copy-area]')) {
    handleCopy(e);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["prod-card"] && !Shopify.designMode) return;
  try {
    const iconItems = document.querySelectorAll('.hs-pcard__icon-item');
iconItems.forEach(function (item) {
    item.addEventListener('click', function (e) {
        e.preventDefault();
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["prod-swp-js"] && !Shopify.designMode) return;
  try {
    // 获取页面中所有匹配的轮播图容器
const splides = document.querySelectorAll('[hs-pswp-js]');
    if (splides.length === 0) {
      return;
    }
if(Swiper) {
    // 遍历每个容器，进行独立的初始化
    splides.forEach(splide => {
        const fullId = splide.id;
        new Swiper(splide, {
            slidesPerView: 'auto',
            grabCursor: true,
            simulateTouch: true,
            slidesPerGroup: 1,
            freeMode: true,
            spaceBetween: 0,
            breakpoints: {
                900: {
                    slidesPerGroup: 3,
                    pagination: {
                      type: 'bullets',
                    }
                }
            },
            navigation: {
                prevEl: ".hs-splide__nav--prev[" + fullId + "]",
                nextEl: ".hs-splide__nav--next[" + fullId + "]"
            },
            pagination: {
                el: ".hs-splide__pgn[" + fullId + "]",
                clickable: true,
                type: "progressbar",
            }
        });
    });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-table-js"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-hs-content] table').forEach((table) => {
    if (table.getAttribute('data-hs-content') === 'true') {
      return;
    }
    const wrapper = document.createElement('div');
    wrapper.className = 'hs-content__scroll-table';
    table.parentNode.insertBefore(wrapper, table);
    table.setAttribute('data-hs-content', 'true');
    wrapper.appendChild(table);
  });
})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast"] && !Shopify.designMode) return;
  try {
    /*!
 * hsToast — 极简 Toast 插件（零依赖，自动注入样式）
 * 用法：
 *   hsToast('success', '操作成功');
 *   hsToast('error', '出错了', { duration: 3000 });
 *   hsToast({ type: 'info', message: '提示', position: 'top-center' });
 */
(function (global) {
  'use strict';

  var STYLE_ID = 'hs-toast-style';
  var containers = {}; // 按 position 缓存容器

  var CSS = `
  .hs-toast-container{position:fixed;z-index:99999;display:flex;flex-direction:column;gap:10px;pointer-events:none;padding:16px;max-width:360px}
  .hs-toast-container[data-pos="top-right"]{top:0;right:0;align-items:flex-end}
  .hs-toast-container[data-pos="top-left"]{top:0;left:0;align-items:flex-start}
  .hs-toast-container[data-pos="top-center"]{top:0;left:50%;transform:translateX(-50%);align-items:center}
  .hs-toast-container[data-pos="bottom-right"]{bottom:0;right:0;align-items:flex-end;flex-direction:column-reverse}
  .hs-toast-container[data-pos="bottom-left"]{bottom:0;left:0;align-items:flex-start;flex-direction:column-reverse}
  .hs-toast-container[data-pos="bottom-center"]{bottom:0;left:50%;transform:translateX(-50%);align-items:center;flex-direction:column-reverse}
  .hs-toast{pointer-events:auto;display:flex;align-items:center;gap:10px;min-width:200px;max-width:360px;padding:12px 14px;border-radius:10px;background:#333;color:#fff;font-size:14px;line-height:1.4;box-shadow:0 6px 20px rgba(0,0,0,.18);opacity:0;transform:translateY(-8px);transition:opacity .25s ease,transform .25s ease;word-break:break-word}
  .hs-toast.is-show{opacity:1;transform:translateY(0)}
  .hs-toast.is-hide{opacity:0;transform:translateY(-8px)}
  .hs-toast__icon{flex:0 0 auto;width:18px;height:18px;display:inline-flex}
  .hs-toast__icon svg{width:100%;height:100%}
  .hs-toast__msg{flex:1 1 auto}
.hs-toast__close{flex:0 0 auto;cursor:pointer;opacity:.7;background:none;border:0;color:inherit;padding:0;display:inline-flex;width:16px;height:16px}
.hs-toast__close:hover{opacity:1}
.hs-toast__close svg{width:100%;height:100%}
  .hs-toast--success{background:#16a34a}
  .hs-toast--error{background:#dc2626}
  .hs-toast--warning{background:#d97706}
  .hs-toast--info{background:#2563eb}
  @media (prefers-reduced-motion:reduce){.hs-toast{transition:none}}
  `;

  var ICONS = {
    success: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    error:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    warning: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 9v4m0 4h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/></svg>',
    info:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16v-4m0-4h.01"/><circle cx="12" cy="12" r="9"/></svg>'
  };

  var defaults = {
    type: 'info',
    message: '',
    duration: 3000,     // 0 表示不自动关闭
    position: 'top-center',
    closable: false,    // 是否显示关闭按钮
    html: false         // 是否按 HTML 渲染 message
  };

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function getContainer(position) {
    if (containers[position] && document.body.contains(containers[position])) {
      return containers[position];
    }
    var el = document.createElement('div');
    el.className = 'hs-toast-container';
    el.setAttribute('data-pos', position);
    document.body.appendChild(el);
    containers[position] = el;
    return el;
  }

  function normalize(a, b, c) {
    // 支持 (type, message, options) 或 (options) 两种调用
    if (typeof a === 'object' && a !== null) return Object.assign({}, defaults, a);
    return Object.assign({}, defaults, c || {}, { type: a, message: b });
  }

  function toast(a, b, c) {
    injectStyle();
    var opts = normalize(a, b, c);
    var type = ICONS[opts.type] ? opts.type : 'info';
    var container = getContainer(opts.position);

    var el = document.createElement('div');
    el.className = 'hs-toast hs-toast--' + type;
    el.setAttribute('role', type === 'error' || type === 'warning' ? 'alert' : 'status');

    var msgEl = document.createElement('div');
    msgEl.className = 'hs-toast__msg';
    if (opts.html) msgEl.innerHTML = opts.message;
    else msgEl.textContent = opts.message;

    el.innerHTML = '<span class="hs-toast__icon">' + ICONS[type] + '</span>';
    el.appendChild(msgEl);

    var timer = null;
    function close() {
      if (!el.parentNode) return;
      clearTimeout(timer);
      el.classList.remove('is-show');
      el.classList.add('is-hide');
      el.addEventListener('transitionend', function () {
        if (el.parentNode) el.parentNode.removeChild(el);
        // 清理空容器
        if (container.childElementCount === 0 && container.parentNode) {
          container.parentNode.removeChild(container);
          delete containers[opts.position];
        }
      }, { once: true });
    }

if (opts.closable) {
  var btn = document.createElement('button');
  btn.className = 'hs-toast__close';
  btn.type = 'button';
  btn.setAttribute('aria-label', 'Close');
  btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  btn.addEventListener('click', close);
  el.appendChild(btn);
}

    container.appendChild(el);
    // 触发进场动画
    requestAnimationFrame(function () { el.classList.add('is-show'); });

    if (opts.duration > 0) {
      timer = setTimeout(close, opts.duration);
      // 悬停暂停
      el.addEventListener('mouseenter', function () { clearTimeout(timer); });
      el.addEventListener('mouseleave', function () { timer = setTimeout(close, opts.duration); });
    }

    return { close: close, el: el };
  }

  // 快捷方法
  ['success', 'error', 'warning', 'info'].forEach(function (t) {
    toast[t] = function (message, options) {
      return toast(t, message, options);
    };
  });

  // 关闭全部
  toast.clear = function () {
    Object.keys(containers).forEach(function (pos) {
      var c = containers[pos];
      if (c) Array.prototype.forEach.call(c.children, function (child) {
        child.dispatchEvent(new Event('mouseenter')); // 停止计时
      });
      if (c && c.parentNode) c.parentNode.removeChild(c);
      delete containers[pos];
    });
  };

  global.hsToast = toast;
  global.HsToast = toast;
})(window);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["topbar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const banner = document.querySelector(".hs-topbar");
    const slidesCount = banner.querySelectorAll(".swiper-slide").length;
    const isDesignMode = window.Shopify && window.Shopify.designMode;
    if (slidesCount > 1) {
      new Swiper(banner, {
        slidesPerView: 1,
        direction: "vertical",
        loop: true,
        autoplay: isDesignMode ? false : {
          delay: 6000,
          disableOnInteraction: false
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-js"] && !Shopify.designMode) return;
  try {
    function initClickOpenVideoModal(container) {
    if(container && container.addEventListener) {
        container.addEventListener('click', function (e) {
            const item = e.target.closest('[data-vdo-wrap]');
            if (item && container.contains(item)) {
                const template = item.querySelector('template');
                if (template) {
                    e.stopPropagation();
                    const domNode = template.content.cloneNode(true);
                    // 3. 传入 DOM 节点而不是 HTML 字符串
                    if (window?.hs_modal) {
                        window.hs_modal.open(domNode);
                    }
                } else {
                    console.warn('No template found in clicked item:', item);
                }
            }
        });
    }
}

document.addEventListener('hs:vdo:list:init', function (data) {
    if (data && data.detail) {
        const root = data.detail?.root || null;
        if(root) {
            initClickOpenVideoModal(root);
        }
    }
});
  } catch(e) { console.error(e); }
})();

})();
